(() => {
  const dialog = document.querySelector('[data-chikas-nl]');
  if (!dialog) return;

  const KEY = 'chikas:newsletter';
  const SEEN_KEY = 'chikas:newsletter:seen';
  const reduceMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  const ANIM_MS = reduceMotion ? 0 : 360;
  const designMode = Boolean(window.Shopify && window.Shopify.designMode);

  const code = dialog.dataset.code || '';
  const delaySetting = Number(dialog.dataset.delay);
  const delayMs = Number.isFinite(delaySetting) && delaySetting >= 0 ? Math.max(400, delaySetting * 1000) : 6000;
  const root = dialog.dataset.root || '/';
  const cartUrl = dialog.dataset.cartUrl || '/cart';

  const form = dialog.querySelector('#ChikasNewsletterForm');
  const stepForm = dialog.querySelector('[data-nl-step="form"]');
  const stepSuccess = dialog.querySelector('[data-nl-step="success"]');
  const stepMember = dialog.querySelector('[data-nl-step="member"]');
  const errorEl = dialog.querySelector('[data-nl-error-msg]');
  const submitBtn = dialog.querySelector('[data-nl-submit]');
  const nameInput = dialog.querySelector('[data-nl-name]');
  const emailInput = dialog.querySelector('[data-nl-email]');
  const helloEl = dialog.querySelector('[data-nl-hello]');
  const appliedEl = dialog.querySelector('[data-nl-applied]');
  const copyBtn = dialog.querySelector('[data-nl-copy]');

  const readState = () => {
    try {
      return JSON.parse(window.localStorage.getItem(KEY) || 'null');
    } catch (e) {
      return null;
    }
  };
  const writeState = (status) => {
    try {
      window.localStorage.setItem(KEY, JSON.stringify({ status, at: Date.now() }));
    } catch (e) {}
  };
  const isMember = () => dialog.dataset.member === 'true' || (readState() || {}).status === 'subscribed';
  const seenThisVisit = () => {
    try {
      return window.sessionStorage.getItem(SEEN_KEY) === '1';
    } catch (e) {
      return false;
    }
  };
  const markSeen = () => {
    try {
      window.sessionStorage.setItem(SEEN_KEY, '1');
    } catch (e) {}
  };

  let closingTimer = 0;
  const open = () => {
    window.clearTimeout(closingTimer);
    dialog.classList.remove('is-closing');
    if (!dialog.open) dialog.showModal();
    requestAnimationFrame(() => dialog.classList.add('is-open'));
  };
  const close = () => {
    if (!dialog.open) return;
    dialog.classList.remove('is-open');
    dialog.classList.add('is-closing');
    window.clearTimeout(closingTimer);
    closingTimer = window.setTimeout(() => {
      dialog.close();
      dialog.classList.remove('is-closing');
    }, ANIM_MS);
  };

  const showError = (msg) => {
    errorEl.textContent = msg || '';
    errorEl.hidden = !msg;
  };

  const applyDiscount = () => {
    if (!code) return;
    fetch(`${root}discount/${encodeURIComponent(code)}?redirect=${encodeURIComponent(cartUrl)}`, {
      credentials: 'same-origin',
    })
      .then((res) => {
        if (res.ok) appliedEl.hidden = false;
      })
      .catch(() => {});
  };

  const showSuccess = (name) => {
    writeState('subscribed');
    markSeen();
    const first = String(name || '').trim().split(/\s+/)[0];
    helloEl.textContent = first ? `, ${first}` : '';
    stepForm.hidden = true;
    stepSuccess.hidden = false;
    applyDiscount();
  };

  const showMember = () => {
    dialog.classList.add('is-member');
    stepForm.hidden = true;
    stepSuccess.hidden = true;
    stepMember.hidden = false;
  };

  const decode = (s) => {
    const t = document.createElement('textarea');
    t.innerHTML = s;
    return t.value;
  };

  const friendlyError = (raw) => {
    const msg = String(raw || '').toLowerCase();
    if (/email|correo/.test(msg) && /invalid|inválid|valid/.test(msg)) return 'Revisa tu correo electrónico.';
    return 'No pudimos completar tu suscripción. Intenta de nuevo en un momento.';
  };

  form.addEventListener('submit', async (e) => {
    e.preventDefault();
    showError('');
    if (!nameInput.value.trim()) {
      showError('Escribe tu nombre.');
      nameInput.focus();
      return;
    }
    if (!emailInput.value.trim() || !emailInput.checkValidity()) {
      showError('Escribe un correo electrónico válido.');
      emailInput.focus();
      return;
    }

    submitBtn.disabled = true;
    dialog.classList.add('is-busy');
    try {
      const res = await fetch(form.action, {
        method: 'POST',
        body: new FormData(form),
        credentials: 'same-origin',
      });
      if (/\/challenge/.test(res.url)) {
        writeState('pending');
        HTMLFormElement.prototype.submit.call(form);
        return;
      }
      const html = await res.text();
      const posted = /data-nl-posted="true"/.test(html) || /customer_posted=true/.test(res.url);
      const errMatch = html.match(/data-nl-error="([^"]*)"/);
      const errText = errMatch ? decode(errMatch[1]) : '';
      if (posted || /taken|already|registrad|existe/i.test(errText)) {
        showSuccess(nameInput.value);
      } else {
        showError(friendlyError(errText));
      }
    } catch (err) {
      showError('No pudimos conectar. Revisa tu internet e intenta de nuevo.');
    } finally {
      submitBtn.disabled = false;
      dialog.classList.remove('is-busy');
    }
  });

  copyBtn.addEventListener('click', async () => {
    try {
      await navigator.clipboard.writeText(code);
    } catch (e) {
      const range = document.createRange();
      range.selectNodeContents(dialog.querySelector('[data-nl-code]'));
      const sel = window.getSelection();
      sel.removeAllRanges();
      sel.addRange(range);
      document.execCommand('copy');
    }
    copyBtn.textContent = '¡Copiado!';
    copyBtn.classList.add('is-done');
    window.setTimeout(() => {
      copyBtn.textContent = 'Copiar';
      copyBtn.classList.remove('is-done');
    }, 1800);
  });

  dialog.addEventListener('click', (e) => {
    if (e.target === dialog || e.target.closest('[data-chikas-nl-close]')) close();
  });
  dialog.addEventListener('cancel', (e) => {
    e.preventDefault();
    close();
  });

  if (designMode) {
    const sectionEl = dialog.closest('.shopify-section');
    document.addEventListener('shopify:section:select', (e) => {
      if (sectionEl && e.target === sectionEl) open();
    });
    document.addEventListener('shopify:section:deselect', (e) => {
      if (sectionEl && e.target === sectionEl) close();
    });
    return;
  }

  const posted = dialog.querySelector('[data-nl-posted]');
  const postedError = dialog.querySelector('[data-nl-error]');
  const returning = posted || (readState() || {}).status === 'pending';
  if (posted || (returning && /customer_posted=true/.test(window.location.search))) {
    showSuccess('');
    open();
  } else if (postedError && (readState() || {}).status === 'pending') {
    showError(friendlyError(postedError.dataset.nlError));
    open();
  } else if (!seenThisVisit()) {
    let tries = 0;
    const tryOpen = () => {
      if (seenThisVisit()) return;
      if (document.querySelector('dialog[open]') && tries < 10) {
        tries += 1;
        window.setTimeout(tryOpen, 3000);
        return;
      }
      if (document.querySelector('dialog[open]')) return;
      if (isMember()) showMember();
      markSeen();
      open();
    };
    window.setTimeout(tryOpen, delayMs);
  }

  if (/customer_posted=true/.test(window.location.search)) {
    const url = new URL(window.location.href);
    url.searchParams.delete('customer_posted');
    url.hash = '';
    window.history.replaceState(null, '', url.toString());
  }
})();
